<script>
	import {onMount} from 'svelte';
	import Category from './Category.svelte';
	import Item from './Item.svelte';
	import Home from './pages/Home.svelte';
	import Details from './pages/Details.svelte';
	import Contribute from './pages/Contribute.svelte';
	import Pro from './pages/Pro.svelte';

	import { Router, Link, Route, navigate } from 'svelte-routing';
	import { FirebaseApp, Doc, Collection } from 'sveltefire';
    
	import firebase from 'firebase/app';
	import 'firebase/firestore';
	import 'firebase/analytics';

	import algoliasearch from 'algoliasearch/lite';

	import Cookies from 'js-cookie';
	import Stats from './pages/Stats.svelte';
import All from './pages/All.svelte';
	
	const firebaseConfig = {
		apiKey: 'AIzaSyByAk94roXNHMVbSJReAzkD0rPh_jn9F-o',
		authDomain: 'stadia-db.firebaseapp.com',
		databaseURL: 'https://stadia-db.firebaseio.com',
		projectId: 'stadia-db',
		storageBucket: 'stadia-db.appspot.com',
		messagingSenderId: '296754788440',
		appId: '1:296754788440:web:b11db58a6b0fc8f60a322d',
		measurementId: 'G-3CGHSNXX8B'
	};

	firebase.initializeApp(firebaseConfig);

	let country = 'us';
	let currency = {
		'shorthand': 'usd',
		'symbol': '\$'
	};
	let dark = true;
	let showCountry = false;

	export let url;

	function changeCountry() {
		if(country == undefined) return;
		switch(country) {
			case 'us':
				currency.shorthand = 'usd';
				currency.symbol = '\$';
				break;
			case 'de':
				currency.shorthand = 'eur';
				currency.symbol = '€';
				break;
			case 'it':
				currency.shorthand = 'eur';
				currency.symbol = '€';
				break;
			case 'nl':
				currency.shorthand = 'eur';
				currency.symbol = '€';
				break;
			case 'be':
				currency.shorthand = 'eur';
				currency.symbol = '€';
				break;
			case 'es':
				currency.shorthand = 'eur';
				currency.symbol = '€';
				break;
			case 'fr':
				currency.shorthand = 'eur';
				currency.symbol = '€';
				break;
			case 'fi':
				currency.shorthand = 'eur';
				currency.symbol = '€';
				break;
			case 'ie':
				currency.shorthand = 'eur';
				currency.symbol = '€';
				break;
			case 'at':
				currency.shorthand = 'eur';
				currency.symbol = '€';
				break;
			case 'pt':
				currency.shorthand = 'eur';
				currency.symbol = '€';
				break;
			case 'sk':
				currency.shorthand = 'eur';
				currency.symbol = '€';
				break;
			case 'uk':
				currency.shorthand = 'gbp';
				currency.symbol = '£';
				break;
			case 'ca':
				currency.shorthand = 'cad';
				currency.symbol = '\$'
				break;
			case 'se':
				currency.shorthand = 'sek';
				currency.symbol = 'kr.';
				break;
			case 'dk':
				currency.shorthand = 'dkk';
				currency.symbol = 'kr.';
				break;
			case 'no':
				currency.shorthand = 'nok';
				currency.symbol = 'kr.';
				break;
			case 'hu':
				currency.shorthand = 'huf';
				currency.symbol = 'Ft';
				break;
			case 'cz':
				currency.shorthand = 'czk';
				currency.symbol = 'Kč';
				break;
			case 'pl':
				currency.shorthand = 'pln';
				currency.symbol = 'zł';
				break;
			default:
				currency.shorthand = 'usd';
				currency.symbol = '\$';
		}

		Cookies.set('country', country, { expires: 365 });
	}

	function toggle() {
		dark = !dark;
		Cookies.set('dark', dark, { expires: 365 });
	}

	let searchClient;
	let index;
	var query = '';
	var hits = [];

	var resultsRevealed = false;

	onMount(() => {
		country = Cookies.get('country', 'us');
		changeCountry();

		dark = Cookies.get('dark') == 'true' || Cookies.get('dark') == undefined;

		searchClient = algoliasearch(
			'P8BWP9LLFF',
			'3c2904b4639860f78f19b517a9679910'
		);

		index = searchClient.initIndex('games');
	});

	var timer;
	var oldQuery = '';

	async function search(e) {
		if(query !== '' && e.keyCode != 13) {
			resultsRevealed = true;
			if(oldQuery != query) {
				clearTimeout(timer);
				timer = setTimeout(async () => {
					const result = await index.search(query, {
					"getRankingInfo": true,
					"analytics": true,
					"enableABTest": false,
					"hitsPerPage": 10,
					"attributesToRetrieve": "*",
					"attributesToSnippet": "*:20",
					"snippetEllipsisText": "…",
					"responseFields": "*",
					"page": 0,
					"facets": [
					"*"
					]
					});
					hits = result.hits;
					console.log(result);
				}, 300);
				oldQuery = query;
			}
		} else resultsRevealed = false;
	}

	function enter(e) {
		if(e.keyCode == 13) {
			e.preventDefault();
			if(hits[0] != null)
				navigate(`/details/${hits[0].objectID}`);
			resultsRevealed = false;
			return;
		}
	}
</script>

<Router {url}>
<main class:dark>
	<FirebaseApp {firebase} analytics>
		<h1 on:click={() => navigate('/')}>StadiaDB</h1>

		<form class="pure-form">
			<input class="fwm" type="text" bind:value={query} placeholder="Search..." on:keyup={search} on:keydown={enter} />&nbsp;
			<!-- svelte-ignore a11y-no-onchange -->
			<select class="fwm" bind:value={country} on:change={changeCountry}>
				<option value="us">United States</option>
				<option value="de">Germany</option>
				<option value="uk">United Kingdom</option>
				<option value="ca">Canada</option>
				<option value="nl">Netherlands</option>
				<option value="be">Belgium</option>
				<option value="it">Italy</option>
				<option value="no">Norway</option>
				<option value="fr">France</option>
				<option value="se">Sweden</option>
				<option value="es">Spain</option>
				<option value="dk">Denmark</option>
				<option value="fi">Finland</option>
				<option value="ie">Ireland</option>
				<option value="at">Austria</option>
				<option value="pt">Portugal</option>
				<option value="sk">Slovakia</option>
				<option value="hu">Hungary</option>
				<option value="cz">Czechia</option>
				<option value="pl">Poland</option>
			</select>
		</form>
		<div id="hits">
			{#if resultsRevealed}
				<ul style="list-style: none; padding: 0px;">
				{#each hits as hit}
					<li class="searchItem" on:click={() => {navigate(`/details/${hit.objectID}`, true); resultsRevealed = false;}}>
						<b>{hit.title}</b><br />
						<span>{hit.type == 0 ? 'Game' :
							hit.type == 1 && hit.playable ? 'Bundle' :
							hit.type == 1 ? 'Add-on Bundle' :
							hit.type == 2 ? 'Add-on' :
							'Subscription'}</span>
					</li>
				{/each}
				</ul>
			{/if}
		</div>

		<br />
		
		<Route path="/">
			<Home {currency}/>
		</Route>
		<Route path="details/:sku" let:params>
			<Details sku={params.sku} {currency}/>
		</Route>
		<Route path="stats">
			<Stats {currency}/>
		</Route>
		<Route path="contribute" component={Contribute} />
		<Route path="all" component={All} />
		<Route path="pro" component={Pro} />
		
		<br /><br />
		<!-- svelte-ignore a11y-missing-attribute -->
		<a on:click={toggle}>Change Theme</a> <span class="purple">/</span> 
		<!-- svelte-ignore a11y-missing-attribute -->
		<a on:click={() => navigate('/contribute')}>Contribute</a> <span class="purple">/</span> 
		<!-- svelte-ignore a11y-missing-attribute -->
		<a on:click={() => navigate('/stats')}>Statistics</a>
		<br /><br />
		<sup>Country selection has been moved to the top of the page.</sup>
		<div id="country-select" class="pure-form hidden">
			<!-- svelte-ignore a11y-no-onchange -->
			<select bind:value={country} on:change={changeCountry}>
				<option value="us">United States</option>
				<option value="de">Germany</option>
				<option value="uk">United Kingdom</option>
				<option value="ca">Canada</option>
				<option value="nl">Netherlands</option>
				<option value="be">Belgium</option>
				<option value="it">Italy</option>
				<option value="no">Norway</option>
				<option value="fr">France</option>
				<option value="se">Sweden</option>
				<option value="es">Spain</option>
				<option value="dk">Denmark</option>
				<option value="fi">Finland</option>
				<option value="ie">Ireland</option>
				<option value="at">Austria</option>
				<option value="pt">Portugal</option>
				<option value="sk">Slovakia</option>
				<option value="hu">Hungary</option>
				<option value="cz">Czechia</option>
				<option value="pl">Poland</option>
			</select>
		</div>
		<br /><br />
	</FirebaseApp>
</main>
</Router>

<style>
	:global(main.dark) {
		background: #121212;
		color: #eeeeee;
	}

	:global(main.dark) select, :global(main.dark) input {
		filter: invert(1);
		color: black;
	}

	h1 {
		cursor: pointer;
	}

	@media screen and (max-width: 48em) {
		.fwm {
			width: 100%;
		}
	}

	.searchItem {
		cursor: pointer;
		padding: 10px;
	}

	.searchItem:hover {
		background: #cbcbcb;
	}

	:global(main.dark) .searchItem:hover {
		background: #212121;
	}
</style>